import { useMemo } from "react";
import { Transaction } from "types";

export function useFilterTransactions(search: string, bonuses: Transaction[]) {
  return useMemo(() => {
    return bonuses.filter(
      (item) =>
        item.comment?.toLowerCase().includes(search.toLowerCase()) ||
        item.total?.toLowerCase().includes(search.toLowerCase()) ||
        item.time?.toLowerCase().includes(search.toLowerCase()) ||
        item.clientid?.toLowerCase().includes(search.toLowerCase())
    );
  }, [search, bonuses]);
}
